import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { AccessEnterpriseProxy, AccessRoleProxy, LookupProxy } from '@/app/proxy/proxies';
import { CropMapAccessService } from './cropmap-access.service';

export const CropMapRoutes: Route = {
    path: 'cropmap',
    data: { title: 'cropmap' },
    providers: [
        AccessEnterpriseProxy,
        AccessRoleProxy,
        LookupProxy,
        CropMapAccessService,
    ],
    children: [
        {
            path: '',
            pathMatch: 'full',
            redirectTo: 'access-enterprise',
        },
        {
            path: 'access-enterprise',
            loadComponent: () =>
                import('./components/cropmap-access-enterprise/cropmap-access-enterprise.component').then(
                    (m) => m.CropmapAccessEnterpriseComponent
                ),
            data: { title: 'enterprise_access' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'role',
            loadComponent: () => import('./components/cropmap-role/cropmap-role.component').then((m) => m.CropmapRoleComponent),
            data: { title: 'cropmap_roles' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'access-role',
            loadComponent: () => import('./components/cropmap-access-role/cropmap-access-role.component').then((m) => m.CropmapAccessRoleComponent),
            data: { title: 'access-role' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'user',
            loadComponent: () => import('./components/cropmap-user/cropmap-user.component').then((m) => m.CropmapUserComponent),
            data: { title: 'cropmap_users' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'geo-unit-representative',
            loadComponent: () =>
                import('./components/cropmap-geo-unit-representative/cropmap-geo-unit-representative.component').then(
                    (m) => m.CropmapGeoUnitRepresentativeComponent
                ),
            data: { title: 'cropmap_geo_unit_representative' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'geo-unit-representative-import',
            loadComponent: () =>
                import('./components/cropmap-geo-unit-representative-import/cropmap-geo-unit-representative-import.component').then(
                    (m) => m.CropmapGeoUnitRepresentativeImportComponent
                ),
            data: { title: 'geo_unit_representative_import' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'data-availability-schedule',
            loadComponent: () => import('./components/data-availability-schedule/data-availability-schedule.component').then((m) => m.DataAvailabilityScheduleComponent),
            data: { title: 'data_availability_schedule' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'plantation-report',
            loadComponent: () =>
                import('./components/cropmap-plantation-report/cropmap-plantation-report.component').then(
                    (m) => m.CropmapPlantationReportComponent
                ),
            data: { title: 'plantation_report' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'field-observation-questionnaire',
            loadComponent: () =>
                import('./components/cropmap-field-observation-questions/cropmap-field-observation-questions.component').then(
                    (m) => m.CropmapFieldObservationQuestionsComponent
                ),
            data: { title: 'field_observation_questionnaire' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
    ],
};
